// Canonical sub-step id vocabulary covering P0–P11 (all 12 onboarding phases).
import { Schema } from 'effect';

export const onboardingSubStepIds = [
  'p0.1',
  'p0.2',
  'p0.3',
  'p0.4',
  'p0.5',
  'p1.1',
  'p1.2',
  'p1.3',
  'p1.4',
  'p1.5',
  'p1.6',
  'p1.7',
  'p1.8',
  'p2.1',
  'p2.2',
  'p2.3',
  'p2.4',
  'p2.5',
  'p2.6',
  'p3.1',
  'p3.2',
  'p3.3',
  'p3.4',
  'p3.5',
  'p4.1',
  'p4.2',
  'p4.3',
  'p4.4',
  'p4.5',
  'p5.1',
  'p5.2',
  'p5.3',
  'p5.4',
  'p5.5',
  'p5.6',
  'p6.1',
  'p6.2',
  'p6.3',
  'p6.4',
  'p6.5',
  'p7.1',
  'p7.2',
  'p7.3',
  'p8.1',
  'p8.2',
  'p8.3',
  'p8.4',
  'p9.1',
  'p9.2',
  'p9.3',
  'p9.4',
  'p9.5',
  'p9.6',
  'p10.1',
  'p10.2',
  'p10.3',
  'p10.4',
  'p11.1',
  'p11.2',
  'p11.3',
  'p11.4',
  'p11.5',
  'p11.6',
] as const;

export const onboardingSubStepIdSchema = Schema.Literals(onboardingSubStepIds)
  .pipe(Schema.brand('OnboardingSubStepId'))
  .annotate({
    title: 'Power onboarding sub-step id',
    description: 'Canonical onboarding sub-step identifiers for phases P0–P11.',
  });
export type OnboardingSubStepId = typeof onboardingSubStepIdSchema.Type;

// Mints a branded sub-step id from a compile-time-checked vocabulary member.
export const onboardingSubStepId = (
  value: (typeof onboardingSubStepIds)[number],
): OnboardingSubStepId => onboardingSubStepIdSchema.make(value);
